import * as React from 'react'

import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

interface IProps {
  text: string

  isExpanded?: boolean
  isIconHidden?: boolean
  className?: string

  onToggle?: () => void
}

const ICON_SIZE = 18

function FieldSectionHeader({
  text,
  isExpanded,
  onToggle,
  className,
  isIconHidden = false,
}: IProps) {
  const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon

  return (
    <div
      className={classList({
        'row y-center no-grow pointer': true,
        [className]: !!className,
      })}
      onClick={isIconHidden ? undefined : onToggle}
    >
      {!isIconHidden && (
        <ChevronIcon size={ICON_SIZE} className="text large grey-30 mr10" />
      )}
      <span className="text large grey-30 bold uppercase no-grow nowrap">
        {text}
      </span>
    </div>
  )
}

export default observer(FieldSectionHeader)
